import { isoAgo } from "./fixtures";

/**
 * Biznes sozlamalari (TZ §20.1).
 *
 * Katalog HAQIQIY kalitlar bilan: tasdiqlangan va
 * tasdiqlanmaganlari aralash. Hammasi tasdiqlangan bo'lsa,
 * «Tasdiqlanmagan» ro'yxati bo'sh chiqib, uning mantig'i
 * sinalmay qolardi.
 */

interface Definition {
  key: string;
  category: string;
  par_id?: string;
  owner_role?: string;
  value_type: string;
  scope_kind: string;
  is_feature_flag: boolean;
  default_value: unknown;
  description_uz: string;
  description_ru: string;
  help_uz?: string;
  approved?: unknown;
  version?: number;
  activated_at?: string;
}

const CATALOG: Definition[] = [
  {
    key: "replenishment.ox_default_min_max", category: "REPLENISHMENT", par_id: "PAR-03",
    owner_role: "warehouse_manager", value_type: "OBJECT", scope_kind: "WAREHOUSE",
    is_feature_flag: false, default_value: { min_stock: "0", max_stock: "0" },
    description_uz: "OX yacheykasi uchun standart min/max qoldiq",
    description_ru: "Минимальный и максимальный остаток для ячейки OX",
    help_uz: "Terish katagi bo'shab qolmasligi uchun chegara: qoldiq MIN dan tushsa tizim to'ldirish topshirig'ini o'zi yaratadi. Ikkalasi nol bo'lsa to'ldirish hech qachon boshlanmaydi.",
    approved: { min_stock: "20", max_stock: "120" }, version: 2,
    activated_at: isoAgo(2880),
  },
  {
    key: "replenishment.min_coverage_days", category: "REPLENISHMENT", par_id: "PAR-03",
    owner_role: "warehouse_manager", value_type: "DECIMAL", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: "1",
    description_uz: "Min chegara necha kunlik talabni qoplaydi",
    description_ru: "Сколько дней спроса покрывает минимум",
    help_uz: "MIN chegara necha kunlik sotuvni qoplashi. Kichik bo'lsa to'ldirish kech boshlanadi va teruvchi kutadi.",
  },
  {
    key: "replenishment.max_coverage_days", category: "REPLENISHMENT", par_id: "PAR-03",
    owner_role: "warehouse_manager", value_type: "DECIMAL", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: "3",
    description_uz: "Max chegara necha kunlik talabni qoplaydi",
    description_ru: "Сколько дней спроса покрывает максимум",
    help_uz: "To'ldirishda katakka necha kunlik zaxira qo'yilishi. Katta bo'lsa tovar terish zonasida uzoq turadi.",
  },
  {
    key: "slotting.abc_thresholds", category: "SLOTTING", par_id: "PAR-03",
    owner_role: "warehouse_manager", value_type: "OBJECT", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: { a: "0.80", b: "0.95" },
    description_uz: "ABC toifalari chegarasi (terish soni bo'yicha)",
    description_ru: "Границы категорий ABC (по числу отборов)",
    help_uz: "Tovarlar terish soniga qarab A, B va C ga bo'linadi: A eng ko'p teriladigani, u eshikka yaqin joyga qo'yiladi.",
    approved: { a: "0.80", b: "0.95" }, version: 1, activated_at: isoAgo(5760),
  },
  {
    key: "slotting.xyz_thresholds", category: "SLOTTING", par_id: "PAR-03",
    owner_role: "warehouse_manager", value_type: "OBJECT", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: { x: "0.10", y: "0.25" },
    description_uz: "XYZ tasnifi chegaralari (haftalik talab variatsiyasi)",
    description_ru: "Пороги XYZ-классификации (вариация недельного спроса)",
    help_uz: "Tovar talabi qanchalik barqaror ekanini belgilaydi: X har hafta bir xil ketadi, Z tartibsiz.",
  },
  {
    key: "slotting.reclassification_period", category: "SLOTTING", par_id: "PAR-03",
    owner_role: "warehouse_manager", value_type: "DURATION", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: "24h",
    description_uz: "ABC qayta hisoblash davri",
    description_ru: "Период пересчёта ABC",
    help_uz: "Toifalar qancha vaqtda bir marta qayta hisoblanishi. Kamdan kam bo'lsa ko'p teriladigan tovar uzoqda qolib ketadi.",
  },
  {
    key: "notification.zone_delay_threshold", category: "NOTIFICATION", par_id: "PAR-05",
    owner_role: "business_owner", value_type: "DURATION", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: "0s",
    description_uz: "Sariq sektorda kechikish chegarasi",
    description_ru: "Порог задержки в жёлтом секторе",
    help_uz: "Pallet sariq yoki qizil sektorda qancha turishi mumkin. Oshsa dispetcherga xabar boradi.",
    approved: "45m", version: 4, activated_at: isoAgo(600),
  },
  {
    key: "notification.channels", category: "NOTIFICATION", par_id: "PAR-05",
    owner_role: "business_owner", value_type: "LIST", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: ["IN_APP"],
    description_uz: "Xabar yuborish yo'llari",
    description_ru: "Каналы доставки уведомлений",
    help_uz: "Xabarlar qaysi yo'l bilan yetkazilishi. Kanal olib tashlansa o'sha yo'l bilan xabar bormaydi.",
    approved: ["IN_APP", "TELEGRAM"], version: 3, activated_at: isoAgo(1440),
  },
  {
    key: "inventory.require_separate_approver", category: "INVENTORY",
    owner_role: "warehouse_manager", value_type: "BOOLEAN", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: true,
    description_uz: "Sanashni tasdiqlovchi sanovchidan boshqa odam bo'lsin",
    description_ru: "Утверждающий пересчёт отличается от счётчика",
    approved: true, version: 1, activated_at: isoAgo(7200),
  },
  {
    key: "control.penalty_scale", category: "CONTROL", par_id: "PAR-05",
    owner_role: "business_owner", value_type: "OBJECT", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: {},
    description_uz: "Nazorat xatolari uchun jarima shkalasi",
    description_ru: "Шкала штрафов — открытый пункт ТЗ §20.1",
    help_uz: "Nazoratda topilgan xatolar uchun KPI dagi jarima ballari. Pul summasi avtomatik hisoblanmaydi.",
  },
  {
    key: "sla.manager_decision", category: "SLA", par_id: "PAR-05",
    owner_role: "business_owner", value_type: "DURATION", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: "0s",
    description_uz: "Menejer qarori uchun muddat",
    description_ru: "Срок для решения менеджера",
    help_uz: "Tovar yetmaganda menejer qaror qabul qilish muddati. Nol bo'lsa kechikish hech qachon aniqlanmaydi.",
  },
  {
    key: "retention.audit_months", category: "RETENTION", par_id: "PAR-07",
    owner_role: "business_owner", value_type: "INTEGER", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: 0,
    description_uz: "Audit yozuvlari necha oy saqlanadi",
    description_ru: "Срок хранения записей аудита, месяцев",
    help_uz: "Kim nima qilgani haqidagi jurnal necha oy saqlanishi. Nol — cheksiz.",
    approved: 60, version: 1, activated_at: isoAgo(4320),
  },
  {
    key: "retention.media_days", category: "RETENTION", par_id: "PAR-07",
    owner_role: "business_owner", value_type: "INTEGER", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: false, default_value: 0,
    description_uz: "Foto va fayllar necha kun saqlanadi",
    description_ru: "Срок хранения фото и файлов, дней",
    help_uz: "Qabul va tafovut fotolari necha kun saqlanishi. Nol — cheksiz, disk asta to'ladi.",
  },
  {
    key: "feature.production_module", category: "FEATURE_FLAG",
    owner_role: "business_owner", value_type: "BOOLEAN", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: true, default_value: true,
    description_uz: "Ishlab chiqarish moduli yoqilganmi",
    description_ru: "Включён ли модуль производства",
    help_uz: "Ishlab chiqarish bo'limi ishlatiladimi. O'chirilsa u panelda ham, TSD da ham ko'rinmaydi.",
  },
  {
    key: "feature.integration_1c", category: "FEATURE_FLAG", par_id: "PAR-06",
    owner_role: "integration_specialist", value_type: "BOOLEAN", scope_kind: "GLOBAL_ONLY",
    is_feature_flag: true, default_value: false,
    description_uz: "1C bilan almashinuv yoqilganmi",
    description_ru: "Включён ли обмен с 1С",
    help_uz: "1C bilan avtomatik almashinuv yoqilganmi. Mapping to'ldirilmasdan yoqilsa kelgan hujjatlar kutib qoladi.",
  },
];

export function definitions() {
  return CATALOG.map(({ approved, version, activated_at, ...rest }) => rest);
}

/** Hal qilingan qiymatlar — amaldagi ro'yxat. */
export function resolved() {
  return CATALOG.map((item) => ({
    key: item.key,
    // Faqat ombor kesimidagi sozlama korpus kodi bilan keladi:
    // haqiqiy API GLOBAL_ONLY uchun «GLOBAL» qaytaradi va panel
    // «A ombori» deb yozib qo'yardi.
    scope: item.scope_kind === "WAREHOUSE" ? "A" : "GLOBAL",
    value: item.approved ?? item.default_value,
    version: item.version ?? 0,
    version_id: item.version ? `ver-${item.key}` : undefined,
    // Tasdiqlanmagan qiymat DEFAULT manbadan keladi va bu
    // ochiq ko'rsatiladi: tasdiqlanmagan parametr bilan
    // ishlash boshqa narsa (TZ §20.1).
    source: item.approved === undefined ? "DEFAULT" : "GLOBAL",
    is_approved: item.approved !== undefined,
    category: item.category,
    value_type: item.value_type,
    par_id: item.par_id,
    owner_role: item.owner_role,
    activated_at: item.activated_at,
  }));
}

export function pending() {
  return resolved().filter((item) => !item.is_approved);
}

/** Bitta sozlamaning versiyalar tarixi. */
export function versions(key: string) {
  const item = CATALOG.find((entry) => entry.key === key);
  if (!item) return [];

  const history: Array<Record<string, unknown>> = [];

  if (item.approved !== undefined) {
    history.push({
      id: `ver-${key}-active`, key, scope: "A", version: item.version ?? 1,
      value: item.approved, status: "ACTIVE",
      reason: "Biznes talabi bo'yicha yangilandi",
      created_by: "Ombor menejeri", created_at: isoAgo(4400),
      approved_by: "Dispetcher", approval_reason: "Hisobot bilan solishtirildi",
      activated_at: item.activated_at,
    });
  }

  history.push({
    id: `ver-${key}-rejected`, key, scope: "A", version: 0,
    value: item.default_value, status: "REJECTED",
    reason: "Dastlabki taklif",
    created_by: "Operator", created_at: isoAgo(9000),
    rejection_reason: "Qiymat asoslanmagan",
  });

  return history;
}
